import React from 'react';
import { gql, useQuery } from '@apollo/client';

import { Card, CardContent } from '@/components/ui/card';
import { OdrLoadingSpinner } from '@/components/ui/spinner';
import {
  MedcallParticipantDetailPage,
  type MedcallBootstrapContext,
} from '@/pages/medcall/MedcallParticipantDetailPage';

const MEDCALL_TAB_BOOTSTRAP = gql`
  query MedcallParticipantTabBootstrap {
    medcallBootstrap {
      defaultLandingPath
      hasSuperAccess
      isAdminUser
      medcallUserId
    }
  }
`;

type MedcallTabBootstrapData = {
  medcallBootstrap?: MedcallBootstrapContext | null;
};

export const MedcallTab = ({ odrparticipant }: { odrparticipant: number }) => {
  const { data, error, loading } = useQuery<MedcallTabBootstrapData>(MEDCALL_TAB_BOOTSTRAP, {
    fetchPolicy: 'cache-and-network',
  });

  if (loading) {
    return <OdrLoadingSpinner />;
  }

  if (error) {
    return (
      <Card>
        <CardContent className="p-[var(--panel-padding)] text-sm text-[var(--semantic-error)]">
          Unable to load MedCall: {error.message}
        </CardContent>
      </Card>
    );
  }

  const bootstrap = data?.medcallBootstrap;
  if (!bootstrap) {
    return (
      <Card>
        <CardContent className="p-[var(--panel-padding)] text-sm text-[var(--neutral-gray-100)]">
          MedCall is unavailable for this participant.
        </CardContent>
      </Card>
    );
  }

  return (
    <MedcallParticipantDetailPage
      bootstrap={bootstrap}
      embedded
      odrparticipant={odrparticipant}
    />
  );
};
